<template>
  <div class="smart">
    <div class="smart-content main-content">
      <h2 class="section-title">智能运维</h2>
      <div class=" rows-2">
        <div class="smart-intro border radius-8 p-32">
          <p class="intro-text">
            智维，致力医院IT管理方案的最佳实践。深耕信息化部门日常运维、业务管理等领域，坚持信创国产化和自主可控，全力助推服务优化、效能提升与信息化高质量建设。
          </p>
          <div class="card-footer">
            <router-link class="btn-chat" to="/free" width="100%">在线留言</router-link>
          </div>
        </div>
        <div class="border radius-8 p-32 smart-list">
          <div class="smart-card">
            <div class="card-content">
              <div class="title-wrapper">
                <h3>数字化运维监控系统</h3>
                <router-link class="link-more" to="/smart">了解更多</router-link>
              </div>
              <p>信息资产CMDB、资产可用性监测、业务健康实时感知</p>
            </div>
            <div class="card-tags">
              <div class="tag">
                信息资产CMDB
              </div>
              <div class="tag">
                资产可用性监测
              </div>
              <div class="tag">
                业务健康实时感知
              </div>
            </div>
          </div>
          <div class="smart-card  pt-32  border-top-dash">
            <div class="card-content">
              <div class="title-wrapper">
                <h3>IT服务流程管理系统</h3>
                <router-link class="link-more" to="/it-service">了解更多</router-link>
              </div>
              <p>聚焦IT管理落实，着力制度流程化</p>
            </div>
            <div class="card-tags">
              <div class="tag">
                AI工单管理
              </div>
              <div class="tag">
                机房智能巡检
              </div>
              <div class="tag">
                AI知识库
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Smart",
  data() {
    return {
      smart: require("./assets/smart.png"),
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 1300px) {
  .section-title {
    font-size: 20px !important;
    font-weight: 600 !important;
    margin-bottom: 12px !important;
  }

  .smart {
    padding: 16px 0 !important;
  }

  .smart-intro {
    height: 214px !important;
  }

  .intro-text {
    font-size: 16px !important;
    line-height: 160% !important;
  }

  .card-footer {
    bottom: 16px !important;
    left: 16px !important;
    right: 16px !important;
  }

  .card-content h3 {
    font-size: 17px !important;
  }

  .border-top-dash {
    margin-top: 16px !important;
  }
}

.smart {
  background: #fff;
  padding: 64px 0 32px;
}

.section-title {
  color: #1f2329;
  font-size: 40px;
  font-weight: 500;
  margin-bottom: 32px;
  text-align: left;
}

.smart-intro {
  text-align: left;
  width: 100%;
  position: relative;
  background: url("../../../assets/home/smart_bg.png"), rgba(255, 255, 255, 0.5);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  height: 481px;
}

.intro-text {
  color: #1f2329;
  text-align: left;
  font-size: 20px;
  font-weight: 500;
  line-height: 170%;
}

.smart-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #FAFBFE;
}

.smart-card {
  flex: 1;
}

.card-content h3 {
  color: #1f2329;
  font-size: 24px;
  font-weight: 500;
}

.card-content p {
  color: #50627f;
  text-align: justify;
  font-size: 16px;
  line-height: 170%;
  /* 27.2px */
  margin-bottom: 18px;
}

.card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag {
  border-radius: 4px;
  background: rgba(56, 111, 198, 0.1);
  display: flex;
  height: 28px;
  padding: 4px 8px;
  align-items: center;
  gap: 10px;
  color: #50627f;
  font-size: 14px;
  font-weight: 400;
  line-height: 170%;
  /* 23.8px */
}

.card-footer {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 32px;
  left: 32px;
  right: 32px;
}

.card-footer .btn-more {
  border-radius: 8px;
  flex: 1;
  margin-right: 16px;
  color: #fff;
  line-height: 48px;
  text-align: left;
  position: relative;
  cursor: pointer;
  overflow: hidden;
}

.card-footer .btn-chat {
  border-radius: 8px;
  height: 48px;
  flex: 1;
  color: #1f2329;
  line-height: 48px;
  padding-left: 24px;
  text-align: left;
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  background: rgba(56, 111, 198, 0.1);
}

.card-footer .btn-chat:hover {
  color: #1cb3b8;
  transform: scale(1.01);
}

.card-footer .btn-chat::after {
  content: "→";
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
}

.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.link-more {
  color: #50627f;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  padding-right: 20px;
}

.link-more::after {
  content: "→";
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
}

.link-more:hover {
  color: #1cb3b8;
}
</style>